import { GroupSecurity } from '@quromedical/fhir-common';
import { withPermissions } from 'components/groups';
import { DeviceListScreen } from 'screens/device';

export default withPermissions(DeviceListScreen, [GroupSecurity.DeviceRead]);
